module.exports = __webpack_public_path__ + "static/media/productos_home_ingredientes.b5a2ceb5.jpg";